import { authenticatedFetch } from '../../../api/utils/request';

export default async function getWebUsers(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener usuarios');
    return await authenticatedFetch('/web-admin-data/all-users', onError);
}
